// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6923c0b4","453":"18a3215b"}[chunkId] + ".chunk.js";
};